<template>
  <div>
    <Form
      :description-title="'Faça o cadastro de um novo item para gerenciar neste setor'"
    >
      <CreateButton
        @click="registerItem()"
        :icon="PhPlus"
        :label="'Adicionar'"
      />
    </Form>
  </div>
</template>

<script setup>
import ExtinguisherService from '../../service/extinguisher.service'
import CreateButton from '@/components/Buttons/Create.vue'
import Form from '../../components/RegisterItensForm.vue'
import { cleanAllFormFields, setFormFieldsError, validateFormField } from '@/helpers/formFieldsHandler'
import { showToast as toast } from '@/helpers/UseToasts'
import { dataExtinguisher } from '../../store'
import { storeApp } from '@/store'
import { onMounted } from 'vue'
import * as yup from '@/validator'
import {
  PhPlus
} from "@phosphor-icons/vue";

const store = dataExtinguisher.state
const appStore = storeApp.state

const schema = yup.object().shape({
  itensForm: yup.object().shape({
    name: yup.string().required('Informe a localização deste item').label('Local'),
    type: yup.object().required('Informe o tipo do item').label('Tipo'),
  })
})

async function registerItem () {
  appStore.loading = true

  cleanAllFormFields()

  const validate = (await validateFormField(schema, store))

  if (validate && validate.length > 0) {
    setFormFieldsError(validate)
    appStore.loading = false
    return
  }

  // fluxo da imagem
  if (
    store.itensForm.images &&
    typeof store.itensForm.images === 'object' &&
    typeof store.itensForm.imagesName === 'string'
  ) {
    await ExtinguisherService.saveImage(store.itensForm.images)
      .then((res) => {
        store.itensForm.imagesName = res.data
        store.itensForm.images = res.data
      })
      .catch((err) =>
        toast(
          'Aviso',
          'Imagem não foi salva',
          'error'
        )
      )
  } else {
    store.itensForm.imagesName = null
    store.itensForm.images = null
  }

  delete store.sectorForm.imageName

  await ExtinguisherService.registerItem(store.sectorId, store.itensForm)
    .then(res => {
      appStore.loading = false
      dataExtinguisher.dispatch('resetForm')

      if (res?.data?.success) {
        Promise.allSettled([
          ExtinguisherService.allExtinguishersBySector(store.sectorId)
            .then(res => {
              if(res?.data[0])
                dataExtinguisher.dispatch('setItemsBySector', res?.data[0]?.itens)
            }).catch(err => {
              storeApp.state.loading = false

              if (err?.response?.data?.error && err.response.data.status === 400) {
                return toast(
                  'Aviso',
                  err.response.data.message,
                  'error'
                )
              }
            
              return toast(
                'Aviso',
                'Algo deu errado ao remover setor',
                'error'
              )
            })
        ])
        
        return toast(
        'Sucesso',
        res.data.message,
        'success'
        )
      }
    }).catch(err => {
      appStore.loading = false

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast(
          'Aviso',
          err.response.data.message,
          'error'
        )
      }

      return toast(
        'Aviso',
        'Algo deu errado ao registrar documento',
        'error'
      )
    })
}

onMounted(async () => {
  appStore.loading = true
  // dataExtinguisher.dispatch('resetForm');
  appStore.loading = false
})

</script>
